import { useContext } from 'react';
import { UserContext } from '../components/UserContext';

const useUserProfile = () => {
  const { user } = useContext(UserContext);
  return {
    email: user?.email || '',
    role: user?.role || '',
    name: user?.userName || '',
    phone: user?.phone || '',
    photo: user?.photo || '',
  };
};

export default useUserProfile;
